import { useQuery } from '@tanstack/react-query'
import { api } from '../../lib/api'
import { Card } from '../../components/ui/Card'
import { StatCard } from '../../components/ui/StatCard'
import { EmptyState } from '../../components/ui/EmptyState'
import { BarChart } from '../../components/charts/BarChart'
import { formatEuro } from '../../lib/format'
import pagina from '../pagine.module.css'

interface Costi {
  mese_corrente: {
    anthropic: number
    deepgram: number
    elevenlabs: number
    twilio: number
    totale: number
  }
  per_sessione_media: number
  per_utente_media: number
  proiezione_fine_mese: number
}

export function AdminCostiAI() {
  const q = useQuery({
    queryKey: ['admin', 'costi-ai'],
    queryFn: async () => (await api.get<{ dati: Costi }>('/superadmin/costi-ai')).data.dati,
  })

  if (q.isLoading) return <div className={pagina.skeleton}>Caricamento…</div>
  if (q.error || !q.data) return <EmptyState titolo="Errore caricamento" />

  const c = q.data
  const breakdown = [
    { servizio: 'Anthropic', costo: c.mese_corrente.anthropic },
    { servizio: 'Deepgram', costo: c.mese_corrente.deepgram },
    { servizio: 'ElevenLabs', costo: c.mese_corrente.elevenlabs },
    { servizio: 'Twilio/Telnyx', costo: c.mese_corrente.twilio },
  ]

  return (
    <div className={pagina.wrap}>
      <div className={pagina.header}>
        <div>
          <h1 className={pagina.titolo}>Costi AI</h1>
          <div className={pagina.sottotitolo}>
            Stima basata su token, minuti audio e caratteri TTS — non chiamate dirette alle API di fatturazione.
          </div>
        </div>
      </div>

      <div className={pagina.griglia}>
        <StatCard etichetta="Mese corrente" valore={formatEuro(c.mese_corrente.totale)} />
        <StatCard etichetta="Proiezione fine mese" valore={formatEuro(c.proiezione_fine_mese)} />
        <StatCard etichetta="Costo medio / sessione" valore={c.per_sessione_media.toFixed(3)} unita="€" />
        <StatCard etichetta="Costo medio / utente" valore={formatEuro(c.per_utente_media)} />
      </div>

      <Card titolo="Breakdown per servizio (mese corrente)">
        <BarChart dati={breakdown} chiaveX="servizio" chiaveY="costo" />
        <div style={{
          marginTop: 16, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12,
        }}>
          {breakdown.map((b) => (
            <div key={b.servizio} style={{
              padding: 12, background: 'var(--bg-subtle)', borderRadius: 'var(--radius-md)',
              display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
            }}>
              <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{b.servizio}</span>
              <span className="mono" style={{ fontWeight: 600 }}>{formatEuro(b.costo)}</span>
            </div>
          ))}
        </div>
      </Card>
    </div>
  )
}
